module.exports = __webpack_public_path__ + "static/media/thumbsup.95e3c4fc.svg";